import React from 'react';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch } from 'react-router';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import Tracking from './components/tracking/Tracking';
import { configureStore } from './store';
import './App.css';

const history = createBrowserHistory();
const rootStore = configureStore();

function App() {
    return (
        <div className='App'>
            <CookiesProvider>
                <Provider store={rootStore}>
                    <Router history={history}>
                        <Switch>
                            <Route exact path={`${process.env.PUBLIC_URL}/tracking`} component={Tracking} />
                        </Switch>
                    </Router>
                </Provider>
            </CookiesProvider>
        </div>
    );
}

export default App;
